import page from 'page'
import appStarterPg from '../../../config/app-starter-pg.js'
import { contentElementId } from '../../../config/config.js'
import { browserAppAccount } from '../../../helpers/app-data-loaders/app-account.js'
import { browserAppUser } from '../../../helpers/app-data-loaders/app-user.js'
import { showPageFinancialsWithConversionPgDetails } from './pg-financials-conversion-details/index.js'
import { showPageFinancialsWithConversionPg } from './pg-financials-conversion/index.js'
import { showPageJournalsMonthlyValuesPgLedger } from './monthly-pnl-values-pg-ledger/index.js'
import { showPageJournalsMonthlyValuesPgLedgerBS } from './monthly-bs-values-pg-ledger/index.js'

/**
 * /app/financials/...
 */
export function setupFinancialsStatementsRoutes (baseRoute) {
  //
  /**
   * Feb 12th 2025: new route for financials pg ledger, with conversion
   *
   * /app/financials/statements/:appAccountId/for/:statementType
   * /app/financials/statements/:appAccountId/for/bs
   * /app/financials/statements/:appAccountId/for/pnl
   */
  page(`${baseRoute}/:appAccountId/for/:statementType`, async function (context) {
    const { appAccountId, statementType } = context.params

    await appStarterPg({
      appAccountId,
      includeEntities: true,
      includeCurrencies: true
    })

    showPageFinancialsWithConversionPg({
      containerElementId: contentElementId,
      browserAppUser,
      browserAppAccount,
      statementType
    })
  })

  /**
   * /app/financials/statements/:appAccountId/details
   */
  page(`${baseRoute}/:appAccountId/details`, async function (context) {
    const { appAccountId } = context.params
    await appStarterPg({
      appAccountId,
      includeEntities: true
    })
    showPageFinancialsWithConversionPgDetails({
      containerElementId: contentElementId,
      browserAppUser,
      browserAppAccount
    })
  })

  /**
   * /app/financials/statements/:appAccountId/monthly-values-ledger-pnl
   */
  page(`${baseRoute}/:appAccountId/monthly-values-ledger-pnl/`, async function (context) {
    const { appAccountId } = context.params
    await appStarterPg({
      appAccountId,
      includeEntities: true
    })
    showPageJournalsMonthlyValuesPgLedger({
      containerElementId: contentElementId,
      browserAppUser,
      browserAppAccount
    })
  })

  /**
   * /app/financials/statements/:appAccountId/monthly-values-ledger-bs
   */
  page(`${baseRoute}/:appAccountId/monthly-values-ledger-bs/`, async function (context) {
    const { appAccountId } = context.params
    await appStarterPg({
      appAccountId,
      includeEntities: true
    })
    showPageJournalsMonthlyValuesPgLedgerBS({
      containerElementId: contentElementId,
      browserAppUser,
      browserAppAccount
    })
  })

  /** In use until Aug 2025 */
  // page('/financials-multi-currency-details/a/:appAccountId', async function (context) {
  //   const { appAccountId } = context.params
  //   location.href = `/app/financials/statements/${appAccountId}/details`
  // })
  // page('/a/:appAccountId/journals-monthly-values-pg-ledger/', async function (context) {
  //   const { appAccountId } = context.params
  //   location.href = `/app/financials/statements/${appAccountId}/monthly-values-ledger-pnl`
  // })
  // page('/financials/statements/:appAccountId/monthly-values-ledger-bs', async function (context) {
  //   const { appAccountId } = context.params
  //   location.href = `/app/financials/statements/${appAccountId}/monthly-values-ledger-bs`
  // })
}
